import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import * as FileSaver from 'file-saver';
import * as React from 'react';
import XLSX from 'sheetjs-style';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import moment from 'moment';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  Tooltip,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  Grid,
} from '@mui/material';

import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2';

import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import dayjs from 'dayjs';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { MuiFileInput } from 'mui-file-input';

import {
  collection,
  getDocs,
  getFirestore,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
  onSnapshot,
  query,
  orderBy,
  limitToLast,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { getStorage, ref, getDownloadURL, uploadBytes } from 'firebase/storage';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// components
import Label from '../../components/label';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/microsite';

import { UserAuth } from '../../context/AuthContext';

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'created', label: 'Created', alignRight: false },
  { id: 'prefix', label: 'Prefix', alignRight: false },
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'subtitle', label: 'Sub Title', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'bgimage', label: 'BG Image', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy2) {
  if (b[orderBy2] < a[orderBy2]) {
    return -1;
  }
  if (b[orderBy2] > a[orderBy2]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy2) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy2)
    : (a, b) => -descendingComparator(a, b, orderBy2);
}

function applySortFilter(array, comparator, query, select) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    if (select === 'title') {
      return filter(array, (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

    if (select === 'id') {
      return filter(array, (_user) => _user.id.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

    if (select === 'prefix') {
      return filter(array, (_user) => _user.prefix.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
  }
  return stabilizedThis.map((el) => el[0]);
}

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

export default function ProductPage() {
  const { user } = UserAuth();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy2, setOrderBy2] = useState('created');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [row, setRow] = useState([]);

  const [fileUrl, setFileUrl] = useState(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [statusdevice, setStatus] = useState('');
  const [emailaddress, setEmail] = useState('');
  const [cityname, setCity] = useState('');
  const [activationDate, setActivationDate] = useState('');
  const [name, setName] = useState('');
  const [mobileNum, setMobileNum] = React.useState('');
  const [userRole, setUserRole] = useState('super_admin');

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const [select, setSelect] = useState('id');

  const handleChangeSelect = (event) => {
    setSelect(event.target.value);
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpen2, setDialogOpen2] = useState(false);
  const [dialogOpen3, setDialogOpen3] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [titleError, setTitleError] = React.useState(false);
  const [subtitleError, setSubTitleError] = React.useState(false);
  const [descError, setDescError] = React.useState(false);

  const [title, setTitle] = React.useState('');
  const [subtitle, setSubTitle] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [file, setFile] = React.useState(null);
  const [videobg, setVideobg] = React.useState(null);
  const [fileInputError, setFileInputError] = React.useState(false);

  const [c1titleError, setc1TitleError] = React.useState(false);
  const [c1descError, setc1DescError] = React.useState(false);
  const [c1title, setc1Title] = React.useState('');
  const [c1description, setc1Description] = React.useState('');
  const [file1, setFile1] = React.useState(null);
  const [file1InputError, setFile1InputError] = React.useState(false);
  const [imgphoto1, setimgphoto1] = React.useState(null);

  const handleOnChangeUploadfile1 = (newFile) => {
    setFile1(newFile);
  };

  const onHandlec1Title = (event) => {
    setc1Title(event.target.value);
  };

  const onHandlec1Description = (event) => {
    setc1Description(event.target.value);
  };

  const [c2titleError, setc2TitleError] = React.useState(false);
  const [c2descError, setc2DescError] = React.useState(false);
  const [c2title, setc2Title] = React.useState('');
  const [c2description, setc2Description] = React.useState('');
  const [file2, setFile2] = React.useState(null);
  const [file2InputError, setFile2InputError] = React.useState(false);
  const [imgphoto2, setimgphoto2] = React.useState(null);

  const handleOnChangeUploadfile2 = (newFile) => {
    setFile2(newFile);
  };

  const onHandlec2Title = (event) => {
    setc2Title(event.target.value);
  };

  const onHandlec2Description = (event) => {
    setc2Description(event.target.value);
  };

  const [c3titleError, setc3TitleError] = React.useState(false);
  const [c3descError, setc3DescError] = React.useState(false);
  const [c3title, setc3Title] = React.useState('');
  const [c3description, setc3Description] = React.useState('');
  const [file3, setFile3] = React.useState(null);
  const [file3InputError, setFile3InputError] = React.useState(false);
  const [imgphoto3, setimgphoto3] = React.useState(null);

  const handleOnChangeUploadfile3 = (newFile) => {
    setFile3(newFile);
  };

  const onHandlec3Title = (event) => {
    setc3Title(event.target.value);
  };

  const onHandlec3Description = (event) => {
    setc3Description(event.target.value);
  };

  const handleOnChangeUploadfile = (newFile) => {
    setFile(newFile);
  };

  const onHandleTitle = (event) => {
    setTitle(event.target.value);
  };

  const onHandleSubTitle = (event) => {
    setSubTitle(event.target.value);
  };

  const onHandleDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogClose2 = () => {
    setDialogOpen2(false);
  };

  const handleDialogClose3 = () => {
    setDialogOpen3(false);
  };

  const handleDialogSubmit = () => {
    update(dbref(rtdb, `event/${selectedItem.id}`), {
      mobile: mobileNum,
      email: emailaddress || null,
      full_name: name,
      status: statusdevice,
      city: cityname,
      purchase_date: activationDate,
    });

    setDialogOpen(false);
  };

  const handleOnDelete = () => {
    setOpenDelete(true);
    setOpen(false);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleSubmitDelete = async () => {
    const currentIndex = row.map((val) => val.id).indexOf(selectedItem.id);

    if (currentIndex > -1) {
      row.splice(currentIndex, 1);
    }

    remove(child(dbref(rtdb), `event/${selectedItem.id}`)).then(() => {
      setOpenDelete(false);
    });
  };

  const onHandleUploadVideo = () => {
    let filePass = false;

    if (file && file.type === 'video/mp4') {
      setFileInputError(false);
      filePass = true;
    } else {
      setFileInputError(true);
    }

    if (filePass) {
      setLoading(true);

      const storage = getStorage(app);
      const storageRef = ref(
        storage,
        `videobackground/${Timestamp.fromDate(new Date()).toMillis()}_${file.name.replace(/\s/g, '')}`
      );

      // Get a key for a new Post.

      uploadBytes(storageRef, file).then((snapshot) => {
        getDownloadURL(ref(storage, snapshot.metadata.fullPath)).then((url1) => {
          update(dbref(rtdb, `home`), {
            bg_fullPath: url1 || null,
            bg_contentType: snapshot.metadata.contentType || null,
          }).then(() => {
            setLoading(false);
            setFile(null);
          });

          setVideobg(url1);
        });
      });
    }
  };

  const onHandleUploadFile1 = () => {
    let filePass = false;

    if (file1 && file1.type === 'image/png') {
      setFile1InputError(false);
      filePass = true;
    } else {
      setFile1InputError(true);
    }

    if (filePass) {
      setLoading(true);

      const storage = getStorage(app);
      const storageRef = ref(
        storage,
        `images/${Timestamp.fromDate(new Date()).toMillis()}_${file1.name.replace(/\s/g, '')}`
      );

      // Get a key for a new Post.

      uploadBytes(storageRef, file1).then((snapshot) => {
        getDownloadURL(ref(storage, snapshot.metadata.fullPath)).then((url1) => {
          update(dbref(rtdb, `home`), {
            file1_fullPath: url1 || null,
            file1_contentType: snapshot.metadata.contentType || null,
          }).then(() => {
            setLoading(false);
            setFile1(null);
          });
          setimgphoto1(url1);
        });
      });
    }
  };

  const onHandleUploadFile2 = () => {
    let filePass = false;

    if (file2 && file2.type === 'image/png') {
      setFile2InputError(false);
      filePass = true;
    } else {
      setFile2InputError(true);
    }

    if (filePass) {
      setLoading(true);

      const storage = getStorage(app);
      const storageRef = ref(
        storage,
        `images/${Timestamp.fromDate(new Date()).toMillis()}_${file2.name.replace(/\s/g, '')}`
      );

      // Get a key for a new Post.

      uploadBytes(storageRef, file2).then((snapshot) => {
        getDownloadURL(ref(storage, snapshot.metadata.fullPath)).then((url1) => {
          update(dbref(rtdb, `home`), {
            file2_fullPath: url1 || null,
            file2_contentType: snapshot.metadata.contentType || null,
          }).then(() => {
            setLoading(false);
            setFile2(null);
          });
          setimgphoto2(url1);
        });
      });
    }
  };

  const onHandleUploadFile3 = () => {
    let filePass = false;

    if (file3 && file3.type === 'image/png') {
      setFile3InputError(false);
      filePass = true;
    } else {
      setFile3InputError(true);
    }

    if (filePass) {
      setLoading(true);

      const storage = getStorage(app);
      const storageRef = ref(
        storage,
        `images/${Timestamp.fromDate(new Date()).toMillis()}_${file3.name.replace(/\s/g, '')}`
      );

      // Get a key for a new Post.

      uploadBytes(storageRef, file3).then((snapshot) => {
        getDownloadURL(ref(storage, snapshot.metadata.fullPath)).then((url1) => {
          update(dbref(rtdb, `home`), {
            file3_fullPath: url1 || null,
            file3_contentType: snapshot.metadata.contentType || null,
          }).then(() => {
            setLoading(false);
            setFile3(null);
          });
          setimgphoto3(url1);
        });
      });
    }
  };

  useEffect(() => {
    let _user = '';
    if (user && user.reloadUserInfo && user.reloadUserInfo.customAttributes) {
      _user = JSON.parse(user.reloadUserInfo.customAttributes);
    }
    setUserRole(_user.role);

    const arr = [];
    get(child(dbref(rtdb), `home`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          setTitle(snapshot.val().title);
          setSubTitle(snapshot.val().subtitle);
          setDescription(snapshot.val().description);
          setVideobg(snapshot.val().bg_fullPath);

          setc1Title(snapshot.val().c1title);
          setc1Description(snapshot.val().c1description);
          setimgphoto1(snapshot.val().file1_fullPath);

          setc2Title(snapshot.val().c2title);
          setc2Description(snapshot.val().c2description);
          setimgphoto2(snapshot.val().file2_fullPath);

          setc3Title(snapshot.val().c3title);
          setc3Description(snapshot.val().c3description);
          setimgphoto3(snapshot.val().file3_fullPath);

          setLoading(false);
        } else {
          setTitle('');
          setSubTitle('');
          setDescription('');
          setVideobg(null);

          setc1Title('');
          setc1Description('');
          setimgphoto1(null);

          setc2Title('');
          setc2Description('');
          setimgphoto2(null);

          setc3Title('');
          setc3Description('');
          setimgphoto3(null);

          setLoading(false);
          console.log('No data available');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getUnique = (arr, index) => {
    const unique = arr
      .map((e) => e[index])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  };

  const handleChangeMobileNum = (event) => {
    setMobileNum(event.trim());
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value.trim());
  };

  const handleChangeCity = (event) => {
    setCity(event.target.value.trim());
  };

  const handleChangeActivationDate = (event) => {
    setActivationDate(event.target.value.trim());
  };

  const handleChangeName = (event) => {
    setName(event.target.value.trim());
  };

  const downloadExcel = async () => {
    setDialogOpen2(true);
  };

  const downloadExcelCreatedDate = async () => {
    setDialogOpen3(true);
  };

  const handleOnDetails = () => {
    setOpenDetails(true);
    setOpen(false);
  };

  const handleOnEdit = () => {
    setEmail(selectedItem.email);
    setActivationDate(selectedItem.purchase_date);
    setCity(selectedItem.city);
    setName(selectedItem.full_name);
    setMobileNum(selectedItem.mobile);
    setDialogOpen(true);
    setOpen(false);
  };

  const handleOpenMenu = (event, row) => {
    setSelectedItem(row);
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy2 === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy2(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = row.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - row.length) : 0;

  const filteredUsers = applySortFilter(row, getComparator(order, orderBy2), filterName, select);

  const isNotFound = !filteredUsers.length && !!filterName;

  if (loading) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  const renderStatus = (status) => {
    let _status = '';
    if (status === 'pending_verification') {
      _status = 'Pending Verification';
    } else if (status === 'verified') {
      _status = 'Verified';
    }

    return _status;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);

    let titlePass = false;
    let subtitlePass = false;
    let descPass = false;

    if (data.get('title').length > 2) {
      titlePass = true;
      setTitleError(false);
    } else {
      setTitleError(true);
    }

    if (data.get('subtitle').length > 2) {
      subtitlePass = true;
      setSubTitleError(false);
    } else {
      setSubTitleError(true);
    }

    if (data.get('description').length > 2) {
      descPass = true;
      setDescError(false);
    } else {
      setDescError(true);
    }

    if (titlePass && descPass && subtitlePass) {
      update(dbref(rtdb, `home`), {
        title: data.get('title'),
        subtitle: data.get('subtitle'),
        description: data.get('description'),
      }).then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  const handleC1Submit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);

    let titlePass = false;
    let descPass = false;

    if (data.get('c1title').length > 2) {
      titlePass = true;
      setc1TitleError(false);
    } else {
      setc1TitleError(true);
    }

    if (data.get('c1description').length > 2) {
      descPass = true;
      setc1DescError(false);
    } else {
      setc1DescError(true);
    }

    if (titlePass && descPass) {
      update(dbref(rtdb, `home`), {
        c1title: data.get('c1title'),
        c1description: data.get('c1description'),
      }).then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  const handleC2Submit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);

    let titlePass = false;
    let descPass = false;

    if (data.get('c2title').length > 2) {
      titlePass = true;
      setc2TitleError(false);
    } else {
      setc2TitleError(true);
    }

    if (data.get('c2description').length > 2) {
      descPass = true;
      setc2DescError(false);
    } else {
      setc2DescError(true);
    }

    if (titlePass && descPass) {
      update(dbref(rtdb, `home`), {
        c2title: data.get('c2title'),
        c2description: data.get('c2description'),
      }).then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  const handleC3Submit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);

    let titlePass = false;
    let descPass = false;

    if (data.get('c3title').length > 2) {
      titlePass = true;
      setc3TitleError(false);
    } else {
      setc3TitleError(true);
    }

    if (data.get('c3description').length > 2) {
      descPass = true;
      setc3DescError(false);
    } else {
      setc3DescError(true);
    }

    if (titlePass && descPass) {
      update(dbref(rtdb, `home`), {
        c3title: data.get('c3title'),
        c3description: data.get('c3description'),
      }).then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title> Home | OneT </title>
      </Helmet>

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Edit</DialogTitle>
        <DialogContent>
          <FormControl style={{ marginTop: 20 }} fullWidth>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select labelId="Status" id="Status" value={statusdevice} label="Status" onChange={handleChangeStatus}>
              <MenuItem value="pending_verification">Pending Verification</MenuItem>
              <MenuItem value="verified">Verified</MenuItem>
            </Select>
          </FormControl>

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={emailaddress}
            onChange={handleChangeEmail}
            autoComplete="off"
            id="outlined-required"
            label="Email Address"
          />

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={cityname}
            onChange={handleChangeCity}
            autoComplete="off"
            id="outlined-required"
            label="City"
          />

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={activationDate}
            onChange={handleChangeActivationDate}
            autoComplete="off"
            id="outlined-required"
            label="Activation Date"
          />

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={name}
            onChange={handleChangeName}
            autoComplete="off"
            id="outlined-required"
            label="Name"
          />

          <PhoneInput
            country="kh"
            inputStyle={{ width: '100%' }}
            containerStyle={{ width: '100%' }}
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={mobileNum}
            onChange={handleChangeMobileNum}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>No</Button>
          <Button onClick={handleDialogSubmit} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete event page</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this page?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>No</Button>
          <Button onClick={handleSubmitDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Home
          </Typography>
        </Stack>

        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container style={{ maxWidth: 500 }}>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                id="title"
                error={titleError}
                onChange={onHandleTitle}
                label="Title"
                value={title}
                name="title"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                required
                onChange={onHandleSubTitle}
                error={subtitleError}
                id="subtitle"
                label="Sub Title"
                name="subtitle"
                value={subtitle}
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                required
                onChange={onHandleDescription}
                error={descError}
                id="description"
                label="Description"
                name="description"
                autoComplete="off"
                value={description}
                multiline
                rows={4}
              />
            </Grid>

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Submit
            </Button>

            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
              <MuiFileInput
                color="primary"
                required
                style={{ width: '100%' }}
                error={fileInputError}
                placeholder="Upload Background Video*"
                getInputText={(value) => (value ? value.name : 'Upload Background Video*')}
                inputProps={{ accept: 'video/mp4' }}
                value={file}
                onChange={handleOnChangeUploadfile}
              />
              <Typography style={{ fontSize: 12, color: 'black', marginTop: 10, opacity: 0.6 }}>
                *Video Resolution (W)1920px x (H)1080px
              </Typography>
            </Grid>
            {videobg ? (
              <Grid item xs={12} md={12} style={{ marginTop: 5 }}>
                <video height={50} playsInline autoPlay loop muted>
                  <source src={videobg} type="video/mp4" />
                </video>
              </Grid>
            ) : null}

            <Button onClick={onHandleUploadVideo} fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Upload Background Video
            </Button>
          </Grid>
        </Box>

        <Divider />

        <Typography style={{ fontSize: 24, color: 'black', marginTop: 10 }}>First Content</Typography>

        <Box component="form" noValidate onSubmit={handleC1Submit} sx={{ mt: 3 }}>
          <Grid container style={{ maxWidth: 500 }}>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                id="c1title"
                error={c1titleError}
                onChange={onHandlec1Title}
                label="Title"
                value={c1title}
                name="c1title"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                required
                onChange={onHandlec1Description}
                error={c1descError}
                id="c1description"
                label="Description"
                name="c1description"
                autoComplete="off"
                value={c1description}
                multiline
                rows={4}
              />
            </Grid>

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Submit
            </Button>

            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
              <MuiFileInput
                color="primary"
                required
                style={{ width: '100%' }}
                error={file1InputError}
                placeholder="Upload Image*"
                getInputText={(value) => (value ? value.name : 'Upload Image*')}
                inputProps={{ accept: 'image/png' }}
                value={file1}
                onChange={handleOnChangeUploadfile1}
              />
              <Typography style={{ fontSize: 12, color: 'black', marginTop: 10, opacity: 0.6 }}>
                *Image Resolution (W)1028px x (H)563px
              </Typography>
            </Grid>
            {imgphoto1 ? (
              <Grid item xs={12} md={12} style={{ marginTop: 5 }}>
                <img height={50} src={imgphoto1} alt="img 1" />
              </Grid>
            ) : null}

            <Button onClick={onHandleUploadFile1} fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Upload Image
            </Button>
          </Grid>
        </Box>

        <Divider />

        <Typography style={{ fontSize: 24, color: 'black', marginTop: 10 }}>Second Content</Typography>

        <Box component="form" noValidate onSubmit={handleC2Submit} sx={{ mt: 3 }}>
          <Grid container style={{ maxWidth: 500 }}>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                id="c2title"
                error={c2titleError}
                onChange={onHandlec2Title}
                label="Title"
                value={c2title}
                name="c2title"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                required
                onChange={onHandlec2Description}
                error={c2descError}
                id="c2description"
                label="Description"
                name="c2description"
                autoComplete="off"
                value={c2description}
                multiline
                rows={4}
              />
            </Grid>

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Submit
            </Button>

            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
              <MuiFileInput
                color="primary"
                required
                style={{ width: '100%' }}
                error={file2InputError}
                placeholder="Upload Image*"
                getInputText={(value) => (value ? value.name : 'Upload Image*')}
                inputProps={{ accept: 'image/png' }}
                value={file2}
                onChange={handleOnChangeUploadfile2}
              />
              <Typography style={{ fontSize: 12, color: 'black', marginTop: 10, opacity: 0.6 }}>
                *Image Resolution (W)1028px x (H)563px
              </Typography>
            </Grid>
            {imgphoto2 ? (
              <Grid item xs={12} md={12} style={{ marginTop: 5 }}>
                <img height={50} src={imgphoto2} alt="img 2" />
              </Grid>
            ) : null}

            <Button onClick={onHandleUploadFile2} fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Upload Image
            </Button>
          </Grid>
        </Box>

        <Divider />

        <Typography style={{ fontSize: 24, color: 'black', marginTop: 10 }}>Third Content</Typography>

        <Box component="form" noValidate onSubmit={handleC3Submit} sx={{ mt: 3 }}>
          <Grid container style={{ maxWidth: 500 }}>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                id="c3title"
                error={c3titleError}
                onChange={onHandlec3Title}
                label="Title"
                value={c3title}
                name="c3title"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                required
                onChange={onHandlec3Description}
                error={c3descError}
                id="c3description"
                label="Description"
                name="c3description"
                autoComplete="off"
                value={c3description}
                multiline
                rows={4}
              />
            </Grid>

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Submit
            </Button>

            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
              <MuiFileInput
                color="primary"
                required
                style={{ width: '100%' }}
                error={file3InputError}
                placeholder="Upload Image*"
                getInputText={(value) => (value ? value.name : 'Upload Image*')}
                inputProps={{ accept: 'image/png' }}
                value={file3}
                onChange={handleOnChangeUploadfile3}
              />
              <Typography style={{ fontSize: 12, color: 'black', marginTop: 10, opacity: 0.6 }}>
                *Image Resolution (W)1028px x (H)563px
              </Typography>
            </Grid>
            {imgphoto3 ? (
              <Grid item xs={12} md={12} style={{ marginTop: 5 }}>
                <img height={50} src={imgphoto3} alt="img 3" />
              </Grid>
            ) : null}

            <Button onClick={onHandleUploadFile3} fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Upload Image
            </Button>
          </Grid>
        </Box>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleOnDelete} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
